import { Box, Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { Pagination } from '@material-ui/lab';
import moment from 'moment';
import React from 'react';
import { useHistory } from "react-router-dom";
import { formatCurrency } from '../../components/CurrencyInput/helpers/CurrencyHelpers';
import SearchField from "../../components/SearchField";
import Page from "../../containers/Page/Page";
import { usePermissions } from '../../hooks/permissions';
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IData {
    data: {
        id: string;
        codigo_sap: string;
        preco_lista: string;
        mercado: string;
        modelo: string;
        data_preco: string;
        ativa: boolean;
        created_at: string;
        tipo: {
            modelo: {
                tipo: string;
            }
        }
    }[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
}

function Tabelas() {

    const history = useHistory();
    const permissions = usePermissions();
    const query = new URLSearchParams(history.location.search);

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [search, setSearch] = React.useState<string>(query.get('search') || '');
    const [data, setData] = React.useState<IData>();

    /**
     * Carregar tabelas de preços.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar tabelas de preços.
     * @param page 
     */
    async function handleFetch(page: number = Number(query.get('page')) || 1) {
        setLoading(true);
        try {
            const url = `/tabelas?search=${search}&page=${page}`;
            const response = await api.get(url);
            history.push(url);
            setData(response.data.object.precos);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    /**
     * Pesquisar com ENTER.
     * @param event 
     */
    function handleSearchKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) {
        if (event.key === 'Enter') {
            handleFetch(1);
        }
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Tabelas de Preços
                </Typography>
                <Box display="flex">
                    {permissions.has('tabela.show') &&
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => history.push('/tabelas/create')}>
                            Nova Tabela
                        </Button>
                    }
                </Box>
            </Page.Title>
            {data &&
                <Page.Section>
                    <Page.Toolbar>
                        <SearchField
                            placeholder="Pesquisa"
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            onKeyUp={(event) => handleSearchKeyUp(event)}
                            onClick={() => handleFetch(1)}
                        />
                    </Page.Toolbar>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Código SAP</TableCell>
                                        <TableCell>Mercado</TableCell>
                                        <TableCell>Tipo</TableCell>
                                        <TableCell>Modelo</TableCell>
                                        <TableCell>Preço de Lista</TableCell>
                                        <TableCell>Data de Preço</TableCell>
                                        <TableCell>Ativo</TableCell>
                                        <TableCell>Data Criação</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.data.map((tabela) => (
                                        <TableRow
                                            key={tabela.id}
                                            hover={true}
                                            onClick={() => history.push(`/tabelas/${tabela.id}`)}
                                        >
                                            <TableCell>{tabela.id}</TableCell>
                                            <TableCell>{tabela.codigo_sap}</TableCell>
                                            <TableCell>{tabela.mercado}</TableCell>
                                            <TableCell>{tabela.tipo ? tabela.tipo.modelo.tipo : 'N/A'}</TableCell>
                                            <TableCell>{tabela.modelo}</TableCell>
                                            <TableCell>{tabela.preco_lista ? formatCurrency('pt-BR', parseFloat(tabela.preco_lista), 'BRL', true) : ''}</TableCell>
                                            <TableCell>{moment(tabela.data_preco).format('DD/MM/YYYY')}</TableCell>
                                            <TableCell>{tabela.ativa ? 'Sim' : 'Não'}</TableCell>
                                            <TableCell>{moment(tabela.created_at).format('DD/MM/YYYY')}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <Grid container justifyContent="center">
                                <Pagination
                                    page={data.current_page}
                                    count={data.last_page}
                                    onChange={(_event, page) => handleFetch(page)}
                                    color="secondary"
                                />
                            </Grid>
                        </Box>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default Tabelas;